import { useEffect } from "react";
import NextLink from "next/link";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Text from "@ds/components/Text";
import { gtmCustomEvent } from "@helpers/analytics";
import FormInterest from "../../form";
import useStyles from "./styles";
import { useTranslation } from "next-i18next";

function InterestForm() {
  const classes = useStyles();
  const { t } = useTranslation("common");

  useEffect(() => {
    gtmCustomEvent(
      {
        eventAction: "Akses Interest Form - General",
        eventCategory: "WebPages",
        eventLabel: "Interest Form - General",
      },
      "LeadGeneral",
    );
  }, []);
  return (
    <GoogleReCaptchaProvider reCaptchaKey={`${process.env.NEXT_PUBLIC_SITE_KEY}`}>
      <Box position="relative">
        <Box>
          <Container
            sx={{
              paddingTop: "6px",
              paddingBottom: "8px",
              maxWidth: "75rem",
            }}
          >
            <NextLink href="/">

              <Box className={classes.backButton}>
                <ArrowBackRounded />
                <Text color="primary-main">{t("root")}</Text>
              </Box>

            </NextLink>
          </Container>
        </Box>
        <Box bgcolor="white" pt={8} pb={12}>
          <Box maxWidth="50rem" margin="auto" mx={3}>
            <Text className={classes.title} align="center" variant="h1" weight="700">
              {t("formInterest.title")}
            </Text>
            <Text align="center" component="p" color="inactive-secondary" variant="body1">
              {t("formInterest.desc")}
            </Text>
            <FormInterest />
          </Box>
        </Box>
      </Box>
    </GoogleReCaptchaProvider>
  );
}

export default InterestForm;
